import React, { useRef, useState,createRef,Component,componentDidMount, forwardRef, useEffect, useContext, useCallback, useMemo } from "react";
import { Box, IconButton, Typegraphy, Typography, useTheme, Button, Icon, debounce, ButtonBase } from '@mui/material';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
// import { createRef } from "react";
import cx from 'classnames';

import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import CloseOverlayBtn from "../buttons/CloseOverlayBtn";
import Shbutton from "../buttons/Shbutton";
// import Inventory2Icon from '@mui/icons-material/Inventory2';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Subheading from "../text/Subheading";
import Text from "../text/Text";
// import Spheadingrow from "./Spheadingrow";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import TabViewBody from "./TabViewBody";
import { useDispatch, useSelector } from "react-redux";
import { resetFilter, setActiveTabChanged, setPreviousRoute } from "../../../newapi/global/filter/gridFilterSlice";
import { useTranslation } from "react-i18next";
import { TabContextProvider } from "../../../contexts/TabContext";
import { generateColorFromTitle, generateIconColorFromTitle } from "./IconColorGenerator";
import SHQuickAction from "../Modal/SHQuickAction";
import ViewsMenu from "./ViewsMenu";

function until(conditionFunction) {

    const poll = resolve => {
        if(conditionFunction()) resolve();
        else setTimeout(_ => poll(resolve), 10);
    }

    return new Promise(poll);
}

const TabView3Content = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const location = useLocation();
    const navigate = useNavigate();
    
    const dispatch =useDispatch();
    const configViews = props.tabConfig;
    const [dataViews, addNewDataView] = useState([]);
    const [activeChild, setActiveChild] = useState(null);
    const [grandchildren, setGrandchildren] = useState([]);

    const [subpanelActive, setSubpanelActive] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const viewType = props.viewType ?? "tabs";

    const showStartIconOnBigScreens = viewType === "bodytabs";

    const replaceView = (data) => {
        addNewDataView( prev => [...prev.map(item => {
            if(item.title === data.title) {
                // Merge so item-only fields (e.g. the `key` used for ?view= URL matching) survive the update.
                return {...item, ...data};
            }
            return item;
        })]);
    }

    // Function to get view name from tab config key or title
    const getViewName = (view, key) => {
        // Use the key from tabConfig if available, otherwise use a sanitized version of the title
        return key || view.title?.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    }

    // Function to find view index by view name
    const findViewIndexByName = (viewName) => {
        if (!dataViews.length || !viewName) return -1;
        
        return dataViews.findIndex((view, index) => {
            const viewKey = getViewName(view, view.key);
            return viewKey === viewName;
        });
    }

    // Function to validate that activeChild matches dataViews
    const validateActiveChild = (childIndex) => {
        if (childIndex === null || !dataViews.length) return null;
        if (childIndex >= 0 && childIndex < dataViews.length) return childIndex;
        return 0; // Fallback to first view if index is invalid
    }

    // Function to update URL with current view
    const updateURLWithView = (viewIndex) => {
        const enableUrlViews = props.enableUrlViews !== false; // Default to true
        if (!enableUrlViews || viewIndex === null || !dataViews[viewIndex]) return;
        
        const view = dataViews[viewIndex];
        const viewName = getViewName(view, view.key);
        
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('view', viewName);
        
        // Use replace to avoid creating too many history entries
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    }

    // Function to get initial view from URL
    const getInitialViewFromURL = () => {
        const enableUrlViews = props.enableUrlViews !== false; // Default to true
        if (!enableUrlViews) return null;
        
        const searchParams = new URLSearchParams(location.search);
        const viewName = searchParams.get('view');
        
        if (viewName) {
            const viewIndex = findViewIndexByName(viewName);
            return viewIndex >= 0 ? viewIndex : null;
        }
        
        return null;
    }

    const handleEvent = useCallback((index) => {
        setActiveChild(index);
        updateURLWithView(index);
        if (window.innerWidth <= 767) {
            setSubpanelActive(true);
        }
    }, [dataViews, location.pathname, navigate, props.enableUrlViews]); // Add dependencies for URL handling
    
    const hasInitialized = useRef(false);

    useEffect(() => {
        if(props.tabConfig){
            addNewDataView([...Object.keys(configViews).map(key => ({
                ...configViews[key],
                key, // Include the original key if needed
            }))]);
        }
    },[configViews])
    
    useEffect(() => {
        // Convert all children to an array for easier manipulation
        let fragmentChildren = React.Children.toArray(props.children);
    
        if(!props.oneView) {
            // Check if the first child is a fragment and if so, use its children instead
            if (fragmentChildren.length === 1 && fragmentChildren[0].type === React.Fragment) {
                fragmentChildren = React.Children.toArray(fragmentChildren[0].props.children);
            }
        
            const activeChildComponent = fragmentChildren.map((child, index) => {
                // Assuming activeChild is the index of the child you want to activate
                if (index === activeChild) {
                    // This is the active child, clone it with additional props
                    return React.cloneElement(child, {
                        key: `active-${index}`,
                        isActive: true,
                        setActiveChild, // Assuming setActiveChild is a function passed as a prop or defined in this component
                        replaceView, // Assuming replaceView is a function passed as a prop or defined in this component
                    });
                }
                return null; // This ensures only the active child is processed
            }).filter(child => child !== null); // Remove nulls, keeping only the active child
            // Update the state to render only the active child component
            setGrandchildren(activeChildComponent);
        } else {
            // console.log(fragmentChildren);
            const grandchildrenWithExtraProp = fragmentChildren.map((child, index) => {
                // console.log("child.props.children",child.props.children);
                if (child.props.children) {
                    return React.Children.map(child.props.children, (grandchild, grandChildIndex) => {
                        return React.cloneElement(grandchild, { 
                            key: `active-${index}`,
                            isActive: true,
                            setActiveChild, // Assuming setActiveChild is a function passed as a prop or defined in this component
                            replaceView, // Assuming replaceView is a function passed as a prop or defined in this component
                        });
                    });
                }
                return child;
            });
            setGrandchildren(grandchildrenWithExtraProp);
        }
    }, [props, activeChild]);

    // Enhanced initialization to handle URL views
    useEffect(() => {
        if (dataViews.length > 0 && !hasInitialized.current) {
            let initialIndex = 0;
            const enableUrlViews = props.enableUrlViews !== false; // Default to true

            // Priority 1: Check URL for view parameter (if enabled)
            const urlViewIndex = getInitialViewFromURL();
            if (urlViewIndex !== null) {
                initialIndex = urlViewIndex;
            }
            // Priority 2: Use defaultTab prop
            else if (typeof props.defaultTab === 'number') {
                initialIndex = Math.min(props.defaultTab, dataViews.length - 1);
            }
            // Priority 3: Default to first tab (0)

            setActiveChild(initialIndex);
            
            // Update URL if URL views are enabled and we're not already showing the URL view
            if (enableUrlViews && urlViewIndex === null) {
                updateURLWithView(initialIndex);
            }
            
            hasInitialized.current = true;
        }
    }, [dataViews, props.defaultTab, props.enableUrlViews]);

    // Listen for URL changes (back/forward navigation)
    useEffect(() => {
        const enableUrlViews = props.enableUrlViews !== false; // Default to true
        if (!enableUrlViews || !hasInitialized.current) return;

        const urlViewIndex = getInitialViewFromURL();
        if (urlViewIndex !== null && urlViewIndex !== activeChild) {
            setActiveChild(urlViewIndex);
        }
    }, [location.search, dataViews, props.enableUrlViews]);

    // Validate activeChild whenever dataViews changes to prevent title mismatch
    useEffect(() => {
        if (dataViews.length > 0 && hasInitialized.current) {
            const validatedIndex = validateActiveChild(activeChild);
            if (validatedIndex !== activeChild) {
                setActiveChild(validatedIndex);
            }
        }
    }, [dataViews]);

    // useEffect(() => {
    //     dispatch(resetFilter());
    // }, [activeChild, dispatch]);


    // useEffect(() => {
    //   window.addEventListener("resize", handleResize);
      
    //   return () => {
    //     window.removeEventListener("resize", handleResize);
    //   }
    // },[])

    useEffect(() => {
        const handleResizeDebounced = debounce(() => {
            setWindowWidth(window.innerWidth);
        }, 100); // Debounce with a 100ms delay
    
        window.addEventListener("resize", handleResizeDebounced);
        
        return () => {
            window.removeEventListener("resize", handleResizeDebounced);
        };
    }, []);

    // Pinned-views mode (opt-in via the pinnedViews prop): only pinned tabs render in the
    // tab row; every view stays reachable through the ViewsMenu dropdown. An unpinned view
    // that is active shows as a temporary tab at the end of the row.
    const pinnedViews = props.pinnedViews;
    const isPinnedMode = Boolean(pinnedViews);
    const pinnedViewsKeys = pinnedViews?.pinnedKeys;
    const pinnedKeys = useMemo(() => pinnedViewsKeys ?? [], [pinnedViewsKeys]);

    const activeViewKey = activeChild !== null && dataViews[activeChild]
        ? getViewName(dataViews[activeChild], dataViews[activeChild].key)
        : null;

    const isMenuView = (view) => !view.component && view.position !== "right";

    const menuViews = useMemo(() => {
        if (!isPinnedMode) return [];
        return dataViews
            .filter(isMenuView)
            .map((view) => ({
                key: getViewName(view, view.key),
                title: view.title,
                group: view.group,
                count: view.count,
                severity: view.severity,
            }));
    }, [isPinnedMode, dataViews]);

    const handleMenuSelect = useCallback((key) => {
        const index = dataViews.findIndex((view) => getViewName(view, view.key) === key);
        if (index >= 0) handleEvent(index);
    }, [dataViews, handleEvent]);

    // Render order for the left tab row. Entries keep their original dataViews index so
    // selection stays index-based; in pinned mode an active-but-unpinned view (the
    // temporary tab) is moved to the end of the row.
    const leftTabEntries = useMemo(() => {
        const entries = dataViews.map((view, index) => ({ view, index }));
        if (!isPinnedMode) return entries;
        const isTemporary = ({ view, index }) =>
            isMenuView(view) && !pinnedKeys.includes(getViewName(view, view.key)) && index === activeChild;
        return [...entries.filter((entry) => !isTemporary(entry)), ...entries.filter(isTemporary)];
    }, [dataViews, isPinnedMode, pinnedKeys, activeChild]);

    const tabStyling = useMemo(() => {
        return viewType == "tabs" ?
            {
                overflowX:"auto",
                paddingX:4,
                display:"flex",
                flexWrap:"nowrap",
                gap:3,
                background: colors.bg["tertiary"],
                minHeight:"40px",
                "@media screen and (max-width: 47.9375em)" : {
                    display:!props.asTab ? "none" : null
                }
            } : viewType == "sidepanel" || viewType == "popup" ?{
                overflowX:"auto",
                paddingX:3,
                display:"flex",
                flexWrap:"nowrap",
                gap:3,
                "@media screen and (max-width: 47.9375em)" : {
                    display:!props.asTab ? "none" : null
                }
            } : viewType === "bodytabs" ? {
                display:"flex",
                flexDirection:"column",
                paddingRight:4,
                gap:1,
                "@media screen and (max-width: 47.9375em)" : {
                    display:!props.asTab ? "none" : null
                }
            } : null;
    },[viewType, props.asTab, theme.palette.mode]);

    return (
        <Box
            sx={props.sx}
        >
            {/* Header tabs, only visible on 768px+ */}
            <Box
                sx={{
                    display:"flex",
                    justifyContent:"space-between",
                    background: viewType !== "bodytabs" ? colors.bg["tertiary"] : null,
                    ...(props.content?.styling?.header?.background && {
                      background: props.content.styling.header.background,
                    }),
                    
                }}
            >
                <Box sx={tabStyling}>
                    {leftTabEntries.map(({ view, index }) => {
                        if (!(typeof view.position === "undefined" || (typeof view.position !== "undefined" && view.position !== "right"))) {
                            return null;
                        }
                        // Pinned mode: unpinned views live in the ViewsMenu dropdown. The active
                        // one still renders — as a temporary tab (leftTabEntries orders it last).
                        if (isPinnedMode && !view.component && !pinnedKeys.includes(getViewName(view, view.key)) && index !== activeChild) {
                            return null;
                        }
                        return (
                            view.component
                            ?
                            view.component
                            :
                            <Shbutton key={index+"dvshol"}
                                onClick={() => handleEvent(index)}
                                isTab={true} 
                                active={index === activeChild}  
                                startIcon={showStartIconOnBigScreens ? view.icon : null}  
                                className={props.tabClasses + " " + view.tabClasses} 
                                variant="text"
                                tabColor={props.tabColor ?? null}
                                sx={view.count > 0 ? {
                                        flexShrink:0,
                                        lineHeight:'unset',
                                        "& .shbtn-content" : {
                                            display:"flex",
                                            alignItems:'center',
                                        }
                                    }
                                    :
                                    {
                                        flexShrink:0,
                                    }
                                }
                            >
                                {t(view.title)}
                                {view.count > 0 && (
                                    view.countHelper ? (
                                        <SHQuickAction component={<Text>{t(view.countHelper)}</Text>}>
                                            {(quickActionProps) => (
                                                <Box
                                                    {...quickActionProps}
                                                    sx={{
                                                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                                        height:24,
                                                        fontWeight:"bold",
                                                        display:"flex",
                                                        alignItems:'center',
                                                        lineHeight:"unset",
                                                        fontFamily:"Roboto, sans-serif",
                                                        borderRadius:3,
                                                        fontSize:"14px",
                                                        fontWeight:'bold',
                                                        px:1,
                                                        ml:1,
                                                        cursor: "help",
                                                    }}
                                                >{view.count}</Box>
                                            )}
                                        </SHQuickAction>
                                    ) : (
                                        <Box
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                                height:24,
                                                fontWeight:"bold",
                                                display:"flex",
                                                alignItems:'center',
                                                lineHeight:"unset",
                                                fontFamily:"Roboto, sans-serif",
                                                borderRadius:3,
                                                fontSize:"14px",
                                                fontWeight:'bold',
                                                px:1,
                                                ml:1,
                                            }}
                                        >{view.count}</Box>
                                    )
                                )}
                            </Shbutton>
                        );
                    })}
                </Box>
                <Box sx={tabStyling}>
                    {dataViews.map((view, index) => (
                        typeof view.position !== "undefined" && view.position === "right" ?
                            view.component 
                            ? 
                            view.component 
                            :
                            <Shbutton key={index+"dvshor"}
                                onClick={() => handleEvent(index)}
                                isTab={true} 
                                active={index === activeChild}  
                                startIcon={showStartIconOnBigScreens ? view.icon : null}  
                                className={props.tabClasses + " " + view.tabClasses} 
                                variant="text"
                                tabColor={props.tabColor ?? null}
                                sx={{
                                    flexShrink:0,
                                }}
                            >
                                {t(view.title)}
                            </Shbutton>
                        : null
                    ))}
                    {isPinnedMode && (
                        <ViewsMenu
                            views={menuViews}
                            groups={pinnedViews.groups ?? []}
                            pinnedKeys={pinnedKeys}
                            activeKey={activeViewKey}
                            onSelectView={handleMenuSelect}
                            onTogglePin={pinnedViews.onTogglePin}
                        />
                    )}
                </Box>
            </Box>

            <Box sx={
                viewType === "tabs" ? {
                    position:"relative",
                    height: "calc(100% - 40px)",
                    zIndex:2,
                    flex:1,
                    display:"flex",
                    alignItems:"stretch",
                    "@media screen and (max-width: 47.9375em)" : {
                        display:"unset",
                    }
                } : viewType === "bodytabs" ? {
                    width:1, 
                    borderTopLeftRadius:"24px",
                    borderTopRightRadius:"24px", 
                    background:`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                    // background:"purple",
                    flex:1,
                    overflow:"auto",
                    display:"flex",
                    flexDirection:"column",
                    "@media screen and (max-width: 47.9375em)" : {
                        background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    }
                } : {
                    width:1, 
                    borderTopLeftRadius:"16px",
                    borderTopRightRadius:"16px", 
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    flex:1,
                    overflow:"auto",
                    zIndex:1,
                    "@media screen and (min-width: 47.9375em) and (max-width: 63.9375em)" : {
                        marginBottom: !props.hideFooter ? viewType !== "popup" ? "80px" : null : null
                    }
                }}
            >
                {/* If phone show btns */}
                {!props.asTab && !props.oneView ?
                    <Box
                        sx={{
                            display:"none",
                            "@media screen and (max-width: 47.9375em)" : {
                                display:"flex",
                                flexWrap:"wrap",
                                flexDirection:"column",
                                gap:1.5,
                                padding:3,
                                marginBottom:!props.hideFooter ? "80px" : null
                            }
                        }}
                    >
                        {dataViews.map((view, index) => (
                            view.component 
                            ? 
                            view.component 
                            :
                            <ButtonBase
                                key={index+"dvshat"}
                                onClick={() => handleEvent(index)}
                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-start",
                                    width:1,
                                    height:40,
                                    borderRadius:5,
                                    px:0.5,
                                    alignItems:'center',
                                    fontSize:14,
                                    fontFamily:"Roboto, sans-serif",
                                    color:colors.txt["primary"],
                                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                    // border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                }}
                            
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:1.5,
                                        fontWeight:"500"
                                    }}
                                >
                                    {view.icon && 
                                        <Box
                                            sx={{
                                                height:32,
                                                width:32,
                                                borderRadius:4,
                                                background:"orange",
                                                background: view.color ?? generateColorFromTitle(view.title, theme.palette.mode),
                                                color: view.iconColor ?? generateIconColorFromTitle(view.title, theme.palette.mode), // icon color
                                                fontSize:8,
                                                display:"flex",
                                                justifyContent:"center",
                                                alignItems:'center',
                                            }}
                                        >
                                            {React.cloneElement(view.icon, { sx: { fontSize: 16 } })} {/* or 18, 22, etc */}
                                        </Box>
                                    }
                                    {t(view.title)}
                                </Box>

                                <Box
                                    sx={{
                                        display:"flex",
                                        ml:"auto",
                                        gap:1,
                                    }}
                                >
                                    {view.count > 0 &&
                                        <Box
                                            sx={{
                                                px:1.5,
                                                height:32,
                                                borderRadius:4,
                                                background:"orange",
                                                background: view.color ?? generateColorFromTitle(view.title, theme.palette.mode),
                                                color: view.iconColor ?? generateIconColorFromTitle(view.title, theme.palette.mode), 
                                                fontSize:14,
                                                display:"flex",
                                                justifyContent:"center",
                                                alignItems:'center',
                                                fontWeight:"bold",
                                            }}
                                        >
                                            {view.count}
                                        </Box>
                                    }
                                    <Box
                                        sx={{
                                            width:32,
                                            height:32,
                                            borderRadius:4,
                                            background:colors.grey[50],
                                            color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["secondary"],
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:'center',
                                        }}
                                    >
                                        <KeyboardArrowRightIcon/>
                                    </Box>
                                </Box>
                            </ButtonBase>
                        ))}
                    </Box>
                :null}
                <TabViewBody
                    activeChild={activeChild}
                    activeTab={activeChild !== null && dataViews[activeChild] ? dataViews[activeChild] : null}
                    // activeView={}
                    // activeTab={activeTab} 
                    subpanelActive={subpanelActive}
                    setSubpanelActive={setSubpanelActive} 
                    // setActiveTab={setActiveTab}
                    viewType={viewType}
                    {...props}
                >
                    
                    {grandchildren}
                </TabViewBody>
            </Box>
        </Box>
    );
};

const TabView3 = (props) => {
    return (
        <TabContextProvider>
            <TabView3Content {...props}/>
        </TabContextProvider>
    )
}
export default TabView3;